import { render, staticRenderFns } from "./setGroupForm.vue?vue&type=template&id=cf5d135c&scoped=true&"
import script from "./setGroupForm.vue?vue&type=script&lang=js&"
export * from "./setGroupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf5d135c",
  null
  
)

export default component.exports